import React from 'react';
import { useLocation } from 'react-router-dom';
import SimpleTabs from '../../../components/tabs/simpleTabs';
import { AnalyticsTabLinks } from '../../../components/enums/tabEnums';
import { useOrganizationSettingsStore } from '../../../store/organizationSettingsStore';
import GoogleTabIcon from '../../../assets/icons/googleAnalyticsIcon.png';

const AnalyticsPage = () => {
    const location = useLocation();
    const activePanel = AnalyticsTabLinks[location.pathname.split('/').pop() as keyof typeof AnalyticsTabLinks] || 0;
    const organizationSettings = useOrganizationSettingsStore((state) => state.organizationSettings);

    return (
        <div>
            <div className={`${organizationSettings.isConnectedToHubspot ? 'h-[91%]' : 'h-full'} 
      rounded-lg border border-dark bg-white  px-6 py-4`}
            >
                <SimpleTabs
                    currentTab={activePanel}
                    tabs={[
                        {
                            tabLabel: 'googleAnalytics',
                            href: 'google-analytics',
                            identifierName: 'google-analytics',
                            icon: GoogleTabIcon,
                        },
                    ]}
                />
            </div>
        </div>
    );
};

export default AnalyticsPage;
